import {Component, OnInit} from '@angular/core';
import {MatDialogRef, MatDialog} from '@angular/material/dialog';
import {PrivacyNoticeModalComponent} from '../privacy-notice-modal/privacy-notice-modal.component';
import {LegalTermsService} from '../../../../../../core/services/legal-terms.service';
import {marked} from 'marked';

@Component({
  selector: 'app-terms-of-use-modal',
  templateUrl: './terms-of-use-modal.component.html',
  styleUrls: ['./terms-of-use-modal.component.scss'],
})
export class TermsOfUseModalComponent implements OnInit {
  content: string | null = null;
  isLoading: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<TermsOfUseModalComponent>,
    public dialog: MatDialog,
    private legalTermsService: LegalTermsService
  ) {
  }

  async ngOnInit() {
    this.isLoading = true;
    const rawContent = await this.legalTermsService.getTermsOfUse();
    if (rawContent) {
      this.content = await marked.parse(rawContent);
    } else {
      this.content = null;
    }
    this.isLoading = false;
  }

  close(): void {
    this.dialogRef.close();
  }

  openPrivacy(): void {
    this.dialogRef.close();
    this.dialog.open(PrivacyNoticeModalComponent, {
      maxWidth: '95vw',
      maxHeight: '90vh',
      width: '800px',
      panelClass: 'responsive-modal'
    });
  }
}
